import { HttpClient, HttpResponse } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Observable } from 'rxjs';
import { CrudService } from '../shared/services/crud.service';
import { EmailMessage } from './email.type';

@Injectable({
    providedIn: 'root'
})
export class EmailService extends CrudService<EmailMessage> {
    constructor(protected http: HttpClient) {
        super(http, 'email');
    }

    downloadAttachment(id: number): Observable<HttpResponse<Blob>> {
        return this.http.get(`/api/${this.apiUrl}/${id}/attachment`, {
            responseType: 'blob',
            observe: 'response'
        });
    }

    resend(id: number, domainClass: string, domainId: string | number | bigint) {
        return this.http.post<EmailMessage>(`/api/${this.apiUrl}/resend`, {
            id: id,
            domainClass: domainClass,
            domainId: domainId
        });
    }
}
